import React from 'react';

import { HistoryProps } from 'utils/history';

import TextileDesignSettingsBackForm from './TextileDesignSettingsBackForm';

export default (props: HistoryProps) => (
  <TextileDesignSettingsBackForm {...props} what="back_header" />
)